// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 30/7/2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';
/** ***************** ADD BRANCH DETAILS START *********************** */
export const branchDetailsAdd = (addData: JSON) => {
	const data = {
		AddBranchDetailsToken: addData,
	};
	const url = `${API_URL}addBranchDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD BRANCH DETAILS END *********************** */

/** ***************** UPDATE BRANCH DETAILS START *********************** */
export const branchDetailsUpdate = (updateData: JSON) => {
	const data = {
		UpdateBranchDetailsToken: updateData,
	};
	const url = `${API_URL}updateBranchDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE BRANCH DETAILS END *********************** */

/** ***************** GET BRANCH DETAILS START *********************** */
export const branchListGet = (listData: any) => {
	const data = {
		GetBranchListToken: listData,
	};
	const url = `${API_URL}getBranchList`;
	return makeApiCall(url, data);
};
/** ***************** GET BRANCH DETAILS END *********************** */

/** ***************** FETCH BRANCH DETAILS START *********************** */
export const branchDetailsFetch = (fetchData: any) => {
	const data = {
		FetchBranchToken: fetchData,
	};
	const url = `${API_URL}fetchBranchDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH BRANCH DETAILS END *********************** */

/** ***************** DELETE BRANCH DETAILS START *********************** */
export const branchDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteBranchDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteBranchDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE BRANCH DETAILS END *********************** */

/** ***************** FETCH SUB BRANCH NEXT UNIQUE ID DETAILS START *********************** */
export const subBranchNextUuniqueIDFetch = (fetchData: any) => {
	const data = {
		FetchSubBranchToken: fetchData,
	};
	const url = `${API_URL}fetchSubBranchNextUniqueID`;
	return makeApiCall(url, data);
};
/** ***************** FETCH SUB BRANCH NEXT UNIQUE ID DETAILS END *********************** */
